<template>
  <header role="banner">
    <div id="default" :class="{ 'large-screen-hide': hideDesktop }">
      <button id="menu-toggle" class="dark large" @click="menuToggle">
        <img
          v-if="!allowWorksFor && !isLoading && account.photoUrl"
          class="menu-toggle-icon"
          :class="{'menu-toggle-logo':isImageLogo}"
          :src="account.photoUrl"
          :alt="$t('profile photo')"
        >
        <avatar
          v-else-if="allowWorksFor && !isLoading"
          :first-name="account.firstName"
          :last-name="account.lastName"
          :other="isLoggedInAsOther"
        />
        <span v-else class="menu-toggle-icon">
          <svgicon name="user" :alt="$t('Profile Icon')" />
        </span>
        <span v-t class="small-screen-hide menu-toggle-label">Menu</span>
      </button>
      <router-link id="header-logo" to="/app/clients" class="dark">
        <banner-logo />
      </router-link>
    </div>

    <router-link v-if="this.$route.path === '/app/overview'" to="/app/clients" class="small-screen-hide back-link dark">
      <svgicon name="arrow-left" :alt="$t('Overview')" class="arrow-left" /><h4 v-t class="header-title">Overview</h4>
    </router-link>

    <router-link v-if="this.$route.path === '/app/revenue'" to="/app/clients" class="small-screen-hide back-link dark">
      <svgicon name="arrow-left" :alt="$t('Revenue')" class="arrow-left" /><h4 v-t class="header-title">Revenue</h4>
    </router-link>

    <router-link v-if="this.$route.path === '/app/resources'" to="/app/clients" class="small-screen-hide back-link dark">
      <svgicon name="arrow-left" :alt="$t('Resources')" class="arrow-left" /><h4 v-t class="header-title">Resources</h4>
    </router-link>
  </header>
</template>

<script>

import '@/lib/icons/user';
import '@/lib/icons/arrow-left';
import '@/lib/icons/search';
import { mapGetters, mapActions } from '@/lib/vue';
import getBrandConfig from '@/lib/utils/get_brand_config';
import Avatar from './avatar';
import BannerLogo from './banner_logo';

import errorStore from '@/store/error';

const brandConfig = getBrandConfig();

const _ = {
  window,
  errorStore,
};

export default {
  _,
  components: {
    Avatar,
    BannerLogo,
  },
  data() {
    return {
      allowWorksFor: brandConfig.allowWorksFor,
      isLoggedInAsOther: false,
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters(['account']),

    hideDesktop() {
      return (this.$route.path === '/app/overview'
        || this.$route.path === '/app/revenue'
        || this.$route.path === '/app/resources');
    },
    isImageLogo() { return this.account && this.account.photoUrl ? this.account.photoUrl.includes('advisor_logo') : false; },
  },

  async created() {
    try {
      await this.fetchAccount();
      if (_.window.localStorage.getItem('originalAdvisorEmail')) {
        this.isLoggedInAsOther = !(_.window.localStorage.getItem('originalAdvisorEmail') === this.account.email);
      }
    } catch (exception) {
      _.errorStore.addError();
    }
    this.isLoading = false;
  },

  methods: {
    ...mapActions(['fetchAccount']),
    menuToggle() {
      this.$emit('menu');
    },
    searchToggle() {
      this.$emit('search');
    },
  },
};
</script>

<style lang="scss" scoped>
  header[role="banner"] {
    background: $white;
    width: 100%;
    z-index: 5;
    border-bottom: 1px solid $pearl-300;
  }

  #header-logo {
    text-decoration: none;
    display: flex;
  }

  #default {
    display: flex;
    position: relative;
    padding: 0.6875rem 0;
    width: 100vw;
    align-items: center;
    justify-content: center;
  }

  #menu-toggle {
    position: absolute;
    left: 1rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0;
  }
  .menu-toggle-label {
    margin-left: 0.5rem;
  }
  .menu-toggle-icon {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background: $neutral-100;
    display: flex;
    align-items: center;
    justify-content: center;
    &.menu-toggle-logo {
      width: 4rem;
      border-radius: 0;
      object-fit: contain;
      background: $white;
    }
  }

  .back-link {
    position: relative;
    left: 0;
    height: 3.5rem;
    display: flex;
    align-items: center;
    color: $black;
    text-decoration: none;
    h4 {
      padding-left: 0.5rem;
      margin: 0;
      @media #{$screen-width-small} { display: inline-block; }
    }
  }

  .hide-desktop {
    @media #{$screen-width-medium} {
      display: none !important;
    }
  }

  .show-desktop {
    display: none;
    @media #{$screen-width-medium} {
      display: flex;
    }
  }

  .arrow-left {
    margin-left: 1rem;
  }
</style>
